export default {
    autenticacao: JSON.parse(localStorage.getItem('autenticacao')) || null,
    centroCusto: JSON.parse(localStorage.getItem('centro_custo')) || {},
    cliente: JSON.parse(localStorage.getItem('cliente') || null),
    customer: JSON.parse(localStorage.getItem('customer')) || null,
    fila: JSON.parse(localStorage.getItem('fila')),
    loading: 0,
    lotacao: JSON.parse(localStorage.getItem('lotacao')) || {},
    menu: JSON.parse(localStorage.getItem('menu')) || null,
    quantidadeNotificacoesNaoLidas: localStorage.getItem('quantidade_notificacoes_nao_lidas') || null,
    routerInfo: null,
    showExitFormConfirmation: false,
    sidebar: localStorage.getItem('sidebar') === 'true' ? true : false,
}